import React from 'react'
import {
	Products,
	Clients,
	Contact
} from './sections'

const Main = () => (
	<main className='flow' id='flow'>
		<Products />
		<Clients />
		<Contact />
	</main>
)

export default Main



// WEBPACK FOOTER //
// ./src/components/ui/Main.js